import { USER_GROUPS } from 'config';
import { ADGEN_PRICER } from 'config/featureFlags';
import { getFlagValue } from './featureFlags';
import { CONTENT_PROMO } from 'components/BuildAd/Steps/CampaignStep/Objective';
import { getCombinedAd } from 'selectors/adCreation';

export const getUser = state => state.user;
export const getGroups = state => (getUser(state) || {}).groups;
export const isUserInGroup = (state, group) => Boolean((getGroups(state) || {})[group]);
export const isPromoterUser = state => isUserInGroup(state, USER_GROUPS.PROMOTER);
export const isInternalUser = state => isUserInGroup(state, USER_GROUPS.INTERNAL);
export const isAdminUser = state => isUserInGroup(state, USER_GROUPS.ADMIN);
export const isMvpUser = state => isUserInGroup(state, USER_GROUPS.MVP_USER);
export const canAccessPricer = state => !!getFlagValue(state, ADGEN_PRICER);
export const isUserPromotingContent = state => {
  const values = getCombinedAd(state);
  return values && values.objective === CONTENT_PROMO;
};



// WEBPACK FOOTER //
// ./src/selectors/user.js